export default "__VITE_PUBLIC_ASSET__1b12019b__"